  $(document).ready(function () {
    $('.reviewCarousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 3000,
      responsive: { 0: { items: 1 }, 600: { items: 1 }, 1000: { items: 1 } },
    });
  });